export default "__VITE_ASSET__7175ec64__"